
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './first-cond-explanation';
const mainimage = '/Images/firstcond1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "firstcond" },
];

const FirstConditional = () => (
  <GrammarPageLayout
    level="B1"
    title="First Conditional"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English First Conditional Exercises"
    seoDescription="Practice real and possible future situations: if + present, will + infinitive. B1 level conditional exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default FirstConditional;

